module.exports = __webpack_public_path__ + "src/theme/fonts/icons/geberitWeb20IconFont.ttf";